import { render } from "./TagModalAddRealm.vue?vue&type=template&id=370ac398&scoped=true"
import script from "./TagModalAddRealm.vue?vue&type=script&lang=js"
export * from "./TagModalAddRealm.vue?vue&type=script&lang=js"

import "./TagModalAddRealm.vue?vue&type=style&index=0&id=370ac398&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-370ac398"]])

export default __exports__